import styled from 'styled-components';

export const DescriptionSubTitle = styled.h3`
  font-size: 14px;
  line-height: 21px;
  color: ${(props) => props.theme.colors['neutral-100']};
  margin-bottom: 8px;
  font-weight: 600;
`;

export const DescriptionText = styled(DescriptionSubTitle)`
  font-weight: 400;
  &:last-of-type {
    margin-bottom: 0;
  }
`;
